import { render, staticRenderFns } from "./DialogOrderRefund.vue?vue&type=template&id=154ec45b&scoped=true"
import script from "./DialogOrderRefund.vue?vue&type=script&lang=js"
export * from "./DialogOrderRefund.vue?vue&type=script&lang=js"
import style0 from "./DialogOrderRefund.vue?vue&type=style&index=0&id=154ec45b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154ec45b",
  null
  
)

export default component.exports